import styled from 'styled-components';

const StyledIcon = styled.img<{ $opacity?: number }>`
	filter: drop-shadow(1px 0 0 rgba(0, 0, 0, 0.25))
		drop-shadow(0 1px 0 rgba(0, 0, 0, 0.25))
		drop-shadow(-1px 0 0 rgba(0, 0, 0, 0.25))
		drop-shadow(0 -1px 0 rgba(0, 0, 0, 0.25));
	user-select: none;
	pointer-events: none;
	opacity: ${(props) => props.$opacity};
`;

export { StyledIcon };
